import * as React from "react"
import { useEffect } from "react"

import { INFOCENTER_ROUTES } from "@constants"
import PageWrapper from "Pages/@PageWrapper"
import { isSystemBusy } from "@signals"
import { resetRetailersTrackedSignals } from "./@signals"
import RetailersTrackedContent from "./Content"

export default function InfoCenterRetailersTrackedPage() {

	useEffect(() => {
		return () => resetRetailersTrackedSignals()
	}, [])

	return <PageWrapper
		head={`DIP Insight | ${INFOCENTER_ROUTES.RETAILERS_TRACKED_TITLE}`}
		title={INFOCENTER_ROUTES.RETAILERS_TRACKED_TITLE}
		subtitle={INFOCENTER_ROUTES.RETAILERS_TRACKED_SUBTITLE}
		hasErrors={isSystemBusy.value}
		actions={null}
	>
		<RetailersTrackedContent />
	</PageWrapper>
}
